<template>
  <todo-list />
</template>

<script>
import TodoList from "@/components/todo/TodoList.vue";

export default {
  components: { TodoList },
  setup() {},
};
</script>
